import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = `${BACKEND}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  timeout: 15000,
});

// ---- Content helpers -----------------------------------------------
export const getServices = () => api.get("/services").then((r) => r.data);
export const getService = (slug) => api.get(`/services/${slug}`).then((r) => r.data);
export const getIndustries = () => api.get("/industries").then((r) => r.data);
export const getIndustry = (slug) => api.get(`/industries/${slug}`).then((r) => r.data);
export const getInsights = (params = {}) =>
  api.get("/insights", { params }).then((r) => r.data);
export const getInsight = (slug) => api.get(`/insights/${slug}`).then((r) => r.data);
export const getRelatedInsights = (slug) =>
  api.get(`/insights/${slug}/related`).then((r) => r.data);
export const getCaseStudies = (params = {}) =>
  api.get("/case-studies", { params }).then((r) => r.data);
export const getCaseStudy = (slug) =>
  api.get(`/case-studies/${slug}`).then((r) => r.data);
export const getTestimonials = () =>
  api.get("/testimonials").then((r) => r.data);
export const getTeam = (params = {}) =>
  api.get("/team", { params }).then((r) => r.data);
export const getCertifications = () =>
  api.get("/certifications").then((r) => r.data);
export const getJobs = (params = {}) =>
  api.get("/jobs", { params }).then((r) => r.data);
export const getJob = (slug) => api.get(`/jobs/${slug}`).then((r) => r.data);
export const getThreatPulse = (limit = 8) =>
  api.get("/threat-pulse/live", { params: { limit } }).then((r) => r.data);
export const getHeroStats = () => api.get("/stats/hero").then((r) => r.data);
export const search = (q, limit = 6) =>
  api.get("/search", { params: { q, limit } }).then((r) => r.data);

// ---- Forms ---------------------------------------------------------
export const submitContact = (payload) =>
  api.post("/contact", payload).then((r) => r.data);
export const subscribeNewsletter = (email, source = "footer") =>
  api.post("/subscribe", { email, source }).then((r) => r.data);
export const submitApplication = (formData) =>
  api
    .post("/applications", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);

// ---- Phase 7 — Tech partners & AI assistant --------------------------
export const getTechPartners = () =>
  api.get("/tech-partners").then((r) => r.data);

/**
 * Stream a chat turn with the AI assistant via Server-Sent Events.
 * onEvent receives {type, data}. type in {"sources","token","done","error"}.
 * Returns a function to abort the stream.
 */
export function streamAssistantChat({ sessionId, message, onEvent }) {
  const controller = new AbortController();
  (async () => {
    try {
      const res = await fetch(`${API_BASE}/assistant/chat`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "text/event-stream" },
        body: JSON.stringify({ session_id: sessionId, message }),
        signal: controller.signal,
      });
      if (!res.ok || !res.body) {
        onEvent({ type: "error", data: { error: `HTTP ${res.status}` } });
        return;
      }
      const reader = res.body.getReader();
      const decoder = new TextDecoder();
      let buffer = "";
      while (true) {
        const { value, done } = await reader.read();
        if (done) break;
        buffer += decoder.decode(value, { stream: true });
        // Split on SSE event delimiter
        const parts = buffer.split("\n\n");
        buffer = parts.pop() || "";
        for (const chunk of parts) {
          const lines = chunk.split("\n").filter(Boolean);
          let type = "message";
          let dataLines = [];
          for (const l of lines) {
            if (l.startsWith("event:")) type = l.slice(6).trim();
            else if (l.startsWith("data:")) dataLines.push(l.slice(5).trim());
          }
          const raw = dataLines.join("\n");
          let data;
          try { data = raw ? JSON.parse(raw) : null; } catch { data = raw; }
          onEvent({ type, data });
        }
      }
    } catch (e) {
      if (e.name !== "AbortError") onEvent({ type: "error", data: { error: e.message } });
    }
  })();
  return () => controller.abort();
}
